// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputSampleView_section__uPJP5 {
  margin-top: 20px;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/examples/views/InputSampleView/InputSampleView.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;AACF","sourcesContent":[".section {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `InputSampleView_section__uPJP5`
};
export default ___CSS_LOADER_EXPORT___;
